module.exports = __webpack_public_path__ + "img/Cricket.c500f65.webp";